export type Unit = {
  id?: number
  label: string
}

export const unitInitValues: Unit = {
  id: undefined,
  label: '',
}
